const menu = [
    {
        label: 'GasCheck',
        icon: 'pi pi-fw pi-home',
        items: [
            {
                label: 'Pregled KGP',
                icon: 'pi pi-fw pi-home',
                to: '/pkgp',
                class: 'text-red-500'
            },
            {
                label: 'Pregled UGI',
                icon: 'pi pi-fw pi-home',
                to: '/pugi',
                class: 'text-red-500'
            },
            {
                label: 'Nedeljni izveštaj',
                icon: 'pi pi-fw pi-chart-bar',
                to: '/nedeljni-izvestaj'
            },
            {
                label: 'Grupe korisnika',
                icon: 'pi pi-fw pi-cog',
                to: '/groups'
            },
            {
                label: 'Merna mesta',
                icon: 'pi pi-fw pi-cog',
                to: '/mm'
            },
            {
                label: 'MRS',
                icon: 'pi pi-fw pi-cog',
                to: '/mrs'
            },
            {
                label: 'Merači',
                icon: 'pi pi-fw pi-cog',
                to: '/m'
            },
            {
                label: 'Potrošači',
                icon: 'pi pi-fw pi-cog',
                to: '/p'
            },
            {
                label: 'Poslovni partner',
                icon: 'pi pi-fw pi-cog',
                to: '/pp'
            }

            // {
            //     label: 'Zamena merača',
            //     icon: 'pi pi-fw pi-home',
            //     to: '/zm',
            //     class: 'text-pink-500'
            // },
        ]
    },

    {
        label: 'Šifarnici',
        icon: 'pi pi-fw pi-book',
        roles: ['super_admin', 'inzenjer', 'admin'],
        items: [
            {
                label: 'Marka trošila',
                icon: 'pi pi-fw pi-cog',
                to: '/markatrosila'
            },
            {
                label: 'Namena potrošnje',
                icon: 'pi pi-fw pi-cog',
                to: '/namenapotrosnje'
            },
            {
                label: 'Način ispitivanja',
                icon: 'pi pi-fw pi-cog',
                to: '/ni'
            },
            {
                label: 'Tip trošila',
                icon: 'pi pi-fw pi-cog',
                to: '/tiptrosila'
            },

            {
                label: 'Vrsta i namena objekta',
                icon: 'pi pi-fw pi-cog',
                to: '/vno'
            },

            {
                label: 'Status instalacije',
                icon: 'pi pi-fw pi-cog',
                to: '/si'
            },
            {
                label: 'Razlog vanr. prov.',
                icon: 'pi pi-fw pi-cog',
                to: '/rvp'
            },
            {
                label: 'Status',
                icon: 'pi pi-fw pi-cog',
                to: '/status'
            }
        ]
    },
    {
        label: 'Izveštaji',
        icon: 'pi pi-fw pi-chart-bar',
        items: [
            {
                label: 'Svi izveštaji',
                icon: 'pi pi-fw pi-table',
                to: '/izvestaji'
            },
            {
                label: 'Distributer',
                icon: 'pi pi-fw pi-download',
                to: '/distributer',
                permission: 'distributer.page'
            }
        ]
    },
    {
        label: 'Users',
        icon: 'pi pi-fw pi-users',
        roles: ['super_admin', 'admin'],
        items: [
            {
                label: 'Korisnici',
                icon: 'pi pi-fw pi-user',
                to: '/users'
            },
            {
                label: 'Vrednost parametra',
                icon: 'pi pi-fw pi-cog',
                to: '/vparam'
            }
        ]
    },
    {
        label: 'Parametri aplikacije',
        icon: 'pi pi-fw pi-lock',
        roles: ['super_admin'],
        items: [
            {
                label: 'Parametri',
                icon: 'pi pi-fw pi-cog',
                to: '/param'
            },

            {
                label: 'Faktura',
                icon: 'pi pi-fw pi-cog',
                to: '/faktura'
            },
            {
                label: 'Prava pristupa',
                icon: 'pi pi-fw pi-cog',
                to: '/permissions'
            },
            {
                label: 'Artikal',
                icon: 'pi pi-fw pi-cog',
                to: '/artikal'
            },

            {
                label: 'Jedinica mere',
                icon: 'pi pi-fw pi-cog',
                to: '/jm'
            },
            {
                label: 'Valuta',
                icon: 'pi pi-fw pi-cog',
                to: '/valuta'
            },
            {
                label: 'Cenovnik',
                icon: 'pi pi-fw pi-cog',
                to: '/cenovnik'
            },

            {
                label: 'Kurs',
                icon: 'pi pi-fw pi-cog',
                to: '/kurs'
            }
        ]
    }
];
export default menu;
